// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-4-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.5 19V15M14.5 15H7V14L13.5 5H14.5V10V15ZM14.5 15H16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers41Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-4-1',
    ref,
    icon: element,
  },
));

Numbers41Icon.displayName = 'Numbers41Icon';

export default Numbers41Icon;
